/* import __COLOCATED_TEMPLATE__ from './column-dropdown.hbs.js'; */
var _dec, _dec2, _class, _class2;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@ember/component';
import { computed } from '@ember/object';
import { Vertical } from '@dashboard/shared-ui/utils/vertical-configs';
import { classNames } from '@ember-decorators/component';

/*
 * This component is used in custom-ember-table and allows the user to select which columns the table should display.
 */
let ColumnDropdown = (_dec = classNames('column-dropdown'), _dec2 = computed('columnsSelected.length', 'maxColumns'), _dec(_class = (_class2 = class ColumnDropdown extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Vertical", Vertical);
    // Passed in:
    _defineProperty(this, "columnsSelected", null);
    _defineProperty(this, "columnsAvailable", null);
    _defineProperty(this, "upsellColumns", null);
    _defineProperty(this, "upsellColumnVertical", null);
    _defineProperty(this, "maxColumns", null);
    _defineProperty(this, "optionsDidChange", () => {});
    _defineProperty(this, "upsellColumnClicked", () => {});
  }
  get maxColumnsReached() {
    // If an "images" column exists, don't count it towards the max selection number
    return this.maxColumns && this.columnsSelected.rejectBy('id', 'IMAGES').length >= this.maxColumns;
  }
}, _applyDecoratedDescriptor(_class2.prototype, "maxColumnsReached", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "maxColumnsReached"), _class2.prototype), _class2)) || _class);
export { ColumnDropdown as default };